<div class="d-flex justify-content-between align-items-center"
    [ngClass]="{'py-3 mt-3 pl-1 border-top': isJobMatchFolders, 'pr-3 pl-1 py-3': !isJobMatchFolders}">
    <span class="text-muted d-block" style="font-size:12px; font-weight:bold;">
        <span *ngIf="!isJobMatchFolders">CANDIDATE DOCUMENTS</span>
        <span *ngIf="isJobMatchFolders" class="py-3">JOB MATCH DOCUMENTS</span>
    </span>
    <div class="d-flex" style="font-size: 21px;" *ngIf="!isJobMatchFolders && !isAvailableDocuments">
        <i class="fas fa-folder-plus cursor-pointer text-primary"
            (click)="addFolder()"></i>
    </div>
</div>
<div [attr.style]="(customStyle ? customStyle + ';' : '') + 'overflow-y:auto; overflow-x:hidden'">
    <div class="row documents-tree">
        <div class="col-sm-12">
            <div *ngIf="folders && folders.length > 0">
                <ul class="list-unstyled">
                    <li class="my-1" *ngFor="let folder of folders" [hidden]="!visible(folder)">
                        <app-documents-tree-node
                            [folder]="folder"
                            [isJobMatchFolders]="isJobMatchFolders"
                            [isAvailableDocuments]="isAvailableDocuments"
                            (selectFolder)="selectFolder($event)"
                            (addFolder)="addFolder($event)"
                            (editFolder)="editFolder($event)"
                            (deleteFolder)="deleteFolder($event)"
                            (moveFolder)="moveFolder($event)"
                            (selectFolderWithDocuments)="selectFolderWithDocuments($event)"
                            (selectAndDeselectDocument)="selectAndDeselectDocument($event)"
                            (documentSelect)="onDocumentSelect($event)">
                        </app-documents-tree-node>
                    </li>
                </ul>
            </div>
            <div *ngIf="(!isAvailableDocuments && !isJobMatchFolders && (!folders || folders.length == 0))
                || (isAvailableDocuments && !isJobMatchFolders && (!availableDocumentsInFolders || availableDocumentsInFolders.length == 0 || !isCandidateDocumentsAvailable))"
                class="d-flex flex-column justify-content-center align-items-center text-muted">
                <p class="mt-3">No folders available</p>
                <button *ngIf="!isAvailableDocuments" class="btn btn-primary" (click)="addFolder()">
                    + Folder
                </button>
            </div>
            <div *ngIf="isJobMatchFolders && ((!folders || folders.length == 0) || !isJobMatchDocumentsAvailable)"
                class="d-flex flex-column justify-content-center align-items-center text-muted">
                <p class="mt-3">No Job Matches Documents</p>
            </div>
        </div>
    </div>
</div>
